import type { PostThumbnail } from "../../types/analytics"

interface PostGridProps {
  posts: PostThumbnail[] | null | undefined
  aspect?: "square" | "vertical"
  emptyMessage?: string
  onPostClick?: (postId: number, accountId?: number) => void
}

const PostGrid = ({
  posts,
  aspect = "square",
  emptyMessage = "データ収集中です",
  onPostClick,
}: PostGridProps) => {
  if (!posts || posts.length === 0) {
    return (
      <div className={`post-grid post-grid--${aspect}`}>
        <div className="post-grid--empty" style={{ gridColumn: "1 / -1" }}>
          {emptyMessage}
        </div>
      </div>
    )
  }

  return (
    <div className={`post-grid post-grid--${aspect}`}>
      {posts.map(post => (
        <div
          key={post.id}
          className={`post-grid-item post-grid-item--${aspect}${onPostClick ? " post-grid-item--clickable" : ""}`}
          onClick={() => onPostClick?.(post.id, post.instagram_account_id)}
        >
          {post.video_url && post.media_type === "VIDEO" ? (
            <video
              src={post.video_url}
              autoPlay
              loop
              muted
              playsInline
              className="post-grid-item__img"
            />
          ) : post.video_url ? (
            <img
              src={post.video_url}
              alt={post.caption ?? ""}
              className="post-grid-item__img"
            />
          ) : post.thumbnail_url ? (
            <img
              src={post.thumbnail_url}
              alt={post.caption ?? ""}
              className="post-grid-item__img"
            />
          ) : (
            <div className="post-grid-item__no-img">📷</div>
          )}
          {post.username && (
            <div
              className="post-grid-item__username"
              style={post.color ? { background: post.color } : undefined}
            >
              @{post.username}
            </div>
          )}
          {post.metric_value != null && (
            <div className="post-grid-item__overlay">
              {post.metric_value.toLocaleString()}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default PostGrid
